import React from 'react'

import { CobrandingLogo } from '@frame/ui-components/cobranding-logo'
import { BaseWidgetHeader } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import { DataAttribute } from '@frame/types'

export function CompleteByOtherStrategy() {
  return (
    <>
      <BaseWidgetHeader />
      <Body data-cy={DataAttribute.SCREEN_TERMINAL_COMPLETE_BY_OTHER_STRATEGY} paddingTopOverride={0} className="p-5">
        <CobrandingLogo />
        <H2 className="my-5 text-center">Verification complete!</H2>
        <P>Your verification was completed using another method. No action needed. You may close this window.</P>
      </Body>
    </>
  )
}
